import type { ExtensionFieldDefinition } from './types.js';

export function defineField(field: ExtensionFieldDefinition) {
  return JSON.stringify(field);
}
